import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertService } from '../components/alert/alert.service';

/** Ruta comodín: avisa de que la dirección no existe y lleva a Inicio. */
export const rutaDesconocidaGuard: CanActivateFn = () => {
  inject(AlertService).warning('La página que buscas no existe.', 5000);
  return inject(Router).createUrlTree(['/home']);
};
